import { render, staticRenderFns } from "./AdminNotification.vue?vue&type=template&id=13de9952&scoped=true&"
import script from "./AdminNotification.vue?vue&type=script&lang=js&"
export * from "./AdminNotification.vue?vue&type=script&lang=js&"
import style0 from "./AdminNotification.vue?vue&type=style&index=0&id=13de9952&lang=scss&scoped=true&"
import style1 from "./AdminNotification.vue?vue&type=style&index=1&id=13de9952&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13de9952",
  null
  
)

export default component.exports